(ns hai.chats.api
  (:require
   [clojure.string :as str]
   [hai.ui.rf-sugar :refer [>e defevent defevent-fx defsub defeffect]]
   [lambdaisland.glogi :as log]
   [humbleai.belt.transit :as transit]
   [hai.web-app.util.fetch :as fetch]
   [cljs-bean.core :as bean]
   [lambdaisland.deja-fu :as fu]))

(defevent-fx ::fetch
  [{:keys [_db]}]
  {:resolve {:query [{:user/chats [:chat/uuid :chat/name :chat/updated-at]}]
             :transform-fn (fn [resp] (get resp :user/chats []))
             :store-in [:chats :all]}})

(defevent-fx ::fetch-active-messages
  [{:keys [db]}]
  (let [chat-uuid (get-in db [:chats :active])]
    {:fetch {:url           (str "/assistant/v1/chats/" chat-uuid "/messages")
             :method        :get
             :transform-fn  vec
             :store-in      [:chats :active-messages]}}))

(defsub ::active-messages [db]
  (get-in db [:chats :active-messages]))

(defsub ::all [db]
  (when-let [chats (get-in db [:chats :all])]
    (sort-by :chat/updated-at #(compare %2 %1) chats)))

(defevent-fx ::fetch-chat-assistant
  [{:keys [_db]} chat-uuid]
  {:fetch {:url "/resolve"
           :method :post
           :body {:query [{:chat/ai-model-config [:ai-model-config/uuid :ai-model-config/title]}]
                  :data {:chat/uuid chat-uuid}}
           :transform-fn (fn [resp] (:chat/ai-model-config resp))
           :store-in [:chats :active-assistant]}})

;; Chat sidebar state and events
(defevent-fx ::select-chat
  [{:keys [db]} chat-id]
  {:db (-> db
           (assoc-in [:chats :active] chat-id)
           (assoc-in [:chats :active-assistant] nil))
   :fx [(when chat-id [:dispatch [::fetch-active-messages]])
        (when chat-id [:dispatch [::fetch-chat-assistant chat-id]])]})

(defevent-fx ::fetch-available-assistants
  [{:keys [_db]}]
  {:resolve {:query [{(list :assistants/table {:pagination {:per-page 100}})
                      [{:collection/items [:ai-model-config/uuid :ai-model-config/title]}]}]
             :transform-fn (fn [resp]
                             (let [items (get-in resp [:assistants/table :collection/items] [])]
                               (zipmap (map :ai-model-config/uuid items) items)))
             :store-in [:chats :available-assistants]}})

(defevent-fx ::on-navigate-by-id [{:keys [db]} chat-uuid]
  (if-let [_new? (get-in db [:chats :new])]
    ;; if a new chat is being created, navigating to the page should
    ;; not load anything as we already load the data locally to show
    ;; optimistic UI updates to the user
    {:db (-> db
             (assoc-in [:chats :new] false))}
    {:db (-> db (assoc-in [:chats :active-messages] []))
     :fx [[:dispatch [::fetch]]
          [:dispatch [::fetch-available-assistants]]
          [:dispatch [::select-chat chat-uuid]]]}))

(defevent-fx ::on-navigate-all [{:keys [db]}]
  {:db (-> db (assoc-in [:chats :new] false))
   :fx [[:dispatch [::fetch]]
        [:dispatch [::fetch-available-assistants]]]})

(defevent-fx ::select-base
  [{:keys [db]} base-id]
  {:db (assoc-in db [:chats :active-base] base-id)})

(defevent ::append-message
  [db {:keys [content]}]
  (update-in db [:chats :active-messages] conj {:message/role :message.role/user
                                                :message/content content}))

(defevent-fx ::create-local-chat
  [{:keys [db]} chat-uuid content]
  (log/info :creating-local-chat chat-uuid)
  (let [now (fu/local-date-time)
        new-chat {:chat/uuid chat-uuid
                  :chat/name "New Chat"
                  :chat/history true
                  :chat/updated-at now
                  :chat/created-at now}]
    {:db (-> db
             (update-in [:chats :all] (fnil conj []) new-chat)
             (assoc-in [:chats :active] chat-uuid)
             (assoc-in [:chats :active-messages] [{:message/role :message.role/user
                                                   :message/content content}]))}))

(defevent-fx ::talk
  [{:keys [db]} {:keys [content base-id]}]
  (let [chat-uuid (get-in db [:chats :active])]
    {;; :db (update-in db [:chats :active-messages ])
     :fetch {:url "/llm/chat/v1"
             :request-id ::talk
             :method :post
             :body (merge
                    {:messages [{:role "user" :content content}]
                     :chat {:chat/uuid chat-uuid}}
                    (when base-id
                      {:rag {:ai-model-config/uuid base-id}
                       :traits {:ai-model-config/uuid base-id}}))
             :on-success-fx [[:dispatch [::select-chat chat-uuid]]]}
     :fx [[:dispatch [::append-message {:content content}]]]}))

(defevent-fx ::talk-new
  [{:keys [_db]} {:keys [content base-id]}]
  (let [chat-uuid (random-uuid)]
    {:fetch {:url "/llm/chat/v1"
             :method :post
             :body (merge
                    {:messages [{:role "user" :content content}]
                     :chat {:chat/uuid chat-uuid
                            :new true}}
                    (when base-id
                      {:rag {:ai-model-config/uuid base-id}
                       :traits {:ai-model-config/uuid base-id}}))
             :on-success-fx [[:dispatch [::generate-name chat-uuid]]
                             [:dispatch [:routing/navigate [:tasks/chats-by-id {:id chat-uuid}]]]]}}))

(defevent-fx ::talk-stream
  [{:keys [db]} {:keys [content chat-uuid base-id]}]
  (let [chat-uuid (or chat-uuid (get-in db [:chats :active]))]
    {:db (-> db (assoc-in [:chats :streaming?] true))
     ::stream {:url "/llm/chat/v1"
               :body (merge
                      {:messages [{:role "user" :content content}]
                       :stream true
                       :chat {:chat/uuid chat-uuid}}
                      (when base-id
                        {:rag {:provider :rag-db
                               :ai-model-config/uuid base-id}
                         :traits {:ai-model-config/uuid base-id}}))
               :on-message (fn [data]
                             (>e [::handle-stream-message data]))
               :on-complete (fn []
                              (>e [::stream-complete chat-uuid]))
               :on-error (fn [error]
                           (>e [::stream-error error]))}
     :fx [[:dispatch [::append-message {:content content}]]]}))

(defsub ::new-chat-first-message [db]
  (get-in db [:chats :new]))

(defevent-fx ::talk-new-stream
  [{:keys [db]} {:keys [content base-id]}]
  (let [chat-uuid (random-uuid)]
    {:db (-> db
             (assoc-in [:chats :new] true)
             (assoc-in [:chats :streaming?] true)
             (assoc-in [:chats :stream-controller] nil)
             #_(assoc-in [:chats :active] nil)
             #_(assoc-in [:chats :active-messages] [{:message/role :message.role/user
                                                     :message/content content}]))
     :fx [[:dispatch [::create-local-chat chat-uuid content]]
          [:dispatch [:routing/navigate [:tasks/chats-by-id {:id chat-uuid}]]]
          [::stream {:url "/llm/chat/v1"
                     :body (merge
                            {:messages [{:role "user" :content content}]
                             :stream true
                             :chat {:chat/uuid chat-uuid
                                    :new true}}
                            (when base-id
                              {:rag {:provider :rag-db
                                     :ai-model-config/uuid base-id}
                               :traits {:ai-model-config/uuid base-id}}))
                     :on-message (fn [data]
                                   (>e [::handle-stream-message data]))
                     :on-complete (fn []
                                    (>e [::stream-complete chat-uuid]))
                     :on-error (fn [error]
                                 (>e [::stream-error error]))}]
          #_[:dispatch-later {:ms 2000 :dispatch [::generate-name chat-uuid]}]]}))

(defevent-fx ::generate-name
  [{:keys [_db]} chat-uuid]
  {:fetch {:url           (str "/assistant/v1/chats/" chat-uuid "/generate-name")
           :method        :post
           :on-success-fx [[:dispatch [::fetch]]]}})

(defevent-fx ::created
  [{:keys [db]} [_ chat]]
  {:db (-> db
           (assoc-in [:assistant :chats (:chat/uuid chat)] chat)
           (assoc-in [:assistant :active-chat-id] (:chat/uuid chat)))})

(defsub ::available-assistants [db]
  (get-in db [:chats :available-assistants]))

(defsub ::active-chat [db]
  (let [chat-uuid (get-in db [:chats :active] nil)
        chats (get-in db [:chats :all])
        active-assistant (get-in db [:chats :active-assistant])]
    (when-let [chat (some->> chats
                             (filter #(= (:chat/uuid %) chat-uuid))
                             first)]
      (cond-> chat
        active-assistant (assoc :chat/ai-model-config active-assistant)))))

(defeffect ::stream
  [{:keys [url body on-message on-complete on-error request-id]
    :or {request-id (gensym "stream-")}}]
  (log/info ::stream-start {:request-id request-id :url url})
  (let [abort-controller (js/AbortController.)
        signal (.-signal abort-controller)
        ;; Buffer for incomplete messages that span chunks
        buffer (atom "")]

    ;; Store abort controller in db
    (>e [::store-stream-controller abort-controller])

    ;; Use fetch with streaming
    (-> (js/fetch url
                  (clj->js {:method "POST"
                            :headers (merge fetch/build-headers
                                            {"Content-Type" "application/transit+json"
                                             "Accept" "text/event-stream"})
                            :body (transit/write body)
                            :signal signal}))
        (.then (fn [response]
                 (when-not (.-ok response)
                   (throw (js/Error. (str "HTTP error: " (.-status response)))))
                 (let [reader (-> response .-body .getReader)
                       decoder (js/TextDecoder.)]

                   ;; Process the stream
                   ((fn read-chunk []
                      (-> (.read reader)
                          (.then (fn [result]
                                   (if (.-done result)
                                     ;; Stream complete - process any remaining buffer
                                     (do
                                       (when (and (not (str/blank? @buffer))
                                                  (str/starts-with? @buffer "data: "))
                                         (let [data (subs @buffer 6)]
                                           (when on-message
                                             (on-message data))))
                                       (log/info ::stream-complete {:request-id request-id})
                                       (when on-complete
                                         (on-complete)))
                                     ;; Process chunk - prepend any buffered content
                                     (let [chunk (str @buffer (.decode decoder (.-value result)))
                                           ;; Split but keep track if chunk ends with newline
                                           ends-with-newline? (str/ends-with? chunk "\n")
                                           lines (str/split chunk #"\n")]
                                       ;; Reset buffer
                                       (reset! buffer "")
                                       ;; If chunk doesn't end with newline, last line is incomplete
                                       (let [complete-lines (if ends-with-newline?
                                                              lines
                                                              (butlast lines))
                                             incomplete-line (when-not ends-with-newline?
                                                               (last lines))]
                                         ;; Buffer incomplete line for next chunk
                                         (when incomplete-line
                                           (reset! buffer incomplete-line))
                                         ;; Process complete lines
                                         (doseq [line complete-lines]
                                           (when (and (not (str/blank? line))
                                                      (str/starts-with? line "data: "))
                                             (let [data (subs line 6)]
                                               (when on-message
                                                 (on-message data))))))
                                       ;; Continue reading
                                       (read-chunk)))))
                          (.catch (fn [error]
                                    (log/error ::stream-read-error {:request-id request-id :error error})
                                    (when on-error
                                      (on-error error))))))))))
        (.catch (fn [error]
                  (log/error ::stream-error {:request-id request-id :error error})
                  (when on-error
                    (on-error error)))))
    ;; Return abort controller so caller can cancel the stream
    abort-controller))

(defevent-fx ::stream [{:keys [db]} opts]
  {:db (-> db
           (assoc-in [:chats :streaming?] true))
   ::stream opts})

(defevent ::store-stream-controller
  [db abort-controller]
  (assoc-in db [:chats :stream-controller] abort-controller))

;; Streaming message handlers
(defevent ::handle-stream-message
  [db data]
  (let [data (some-> data
                     (js/JSON.parse)
                     bean/->clj)]
    (cond
      (:content data)
      (update-in db [:chats :active-messages]
                 (fn [messages]
                   (let [last-msg (last messages)]
                     (if (= (:message/role last-msg) :message.role/assistant)
                       ;; Append to existing assistant message
                       (conj (vec (butlast messages))
                             (update last-msg :message/content str (:content data)))
                       ;; Create new assistant message
                       (conj messages {:message/role :message.role/assistant
                                       :message/content (:content data)})))))

      ;; first message is chat info
      (:chat/uuid data)
      db

      :else
      db)))

(defevent-fx ::stream-complete
  [{:keys [db]} chat-uuid]
  (log/info ::stream-complete {:chat-uuid chat-uuid})
  ;; Clear stream controller and mark streaming as complete
  {:db (-> db
           (assoc-in [:chats :streaming?] false)
           (assoc-in [:chats :stream-controller] nil))
   :fx [[:dispatch [::fetch]]
        [:dispatch [::select-chat chat-uuid]]
        [:dispatch [::generate-name chat-uuid]]]})

(defevent ::stream-error
  [db error]
  (log/error ::stream-error {:error error})
  ;; Clear stream controller and clean up streaming state
  (-> db
      (assoc-in [:chats :streaming?] false)
      (assoc-in [:chats :stream-controller] nil)))

(defeffect ::stream-cancel [{:keys [abort-controller]}]
  (.abort abort-controller))

(defevent-fx ::stream-cancel [{:keys [db]}]
  (log/info ::stream-cancel true)
  (when-let [abort-controller (get-in db [:chats :stream-controller])]
    {:db (-> db
             (assoc-in [:chats :streaming?] false)
             (assoc-in [:chats :stream-controller] nil))
     ::stream-cancel {:abort-controller abort-controller}}))

(defsub ::streaming? [db]
  (get-in db [:chats :streaming?]))
